export default __webpack_public_path__ + "static/media/KeysToMyWishes-PitchDeck.fa81e230.pdf";